function findProductPrice(productId, type){
     var result;
     allProducts.forEach(function(el){
          el.id == Number(productId) && (
               type == "price" ?
               (result = el.price) :
               (result = el.compare)
          )
     })
     return result;
}

function updateCartDrawerSections(cartDrawer, newDrawer, cartBubble, newBubble){
     cartDrawer.outerHTML = newDrawer;
     cartBubble.innerHTML = newBubble;
     setTimeout(() => {
          document.querySelector('cart-drawer').classList.add('active');
     }, 50);
}


function findVariantPrice(variantId, type){
     var result;
     allProducts.forEach(function(el){
          //sticks nrs and prices
          el.variants.forEach(function(variant){
               variant.id == Number(variantId) && (
                    type == "price" ?
                    (result = variant.price) :
                    (result = variant.compare)
               );
          })
     })
     return result;
}


//send view counter request to webhook
async function incrementView(variantId, ab) {
     const url = 'https://app.thebalmydrum.com/webhook';
     const data = {
          name: "viewAllCounter",
          variantId: variantId,
          upsellAB: ab && ab
     };

     try {
          const response = await fetch(url, {
               method: 'POST',
               headers: {
               'Content-Type': 'application/json'
               },
               body: JSON.stringify(data)
          });

          if (!response.ok) {
               throw new Error(`HTTP error! status: ${response.status}`);
          }

          const result = await response.json();
          //console.log(result);
     } catch (error) {
          //console.error('Error:', error);
     }
}

//Add attribute to cart if accept
async function updateCartWithNote(result, ab) {
     const url = window.Shopify.routes.root + 'cart/update.js';
     const data = {
          attributes: {
               upsell: 'true',
               upsellAccept: result,
               upsellAB: ab && ab
          }
     };

     try {
          const response = await fetch(url, {
               method: 'POST',
               headers: {
                    'Content-Type': 'application/json'
               },
               body: JSON.stringify(data)
          });

          if (!response.ok) {
               throw new Error(`HTTP error! status: ${response.status}`);
          }

          const result = await response.json();
          //console.log('Cart updated with upsell note:', result);
     } catch (error) {
          //console.error('Error updating cart with upsell note:', error);
     }
}



document.addEventListener('DOMContentLoaded', function(){

     const pageForms = document.querySelectorAll('form[action="/cart/add"]');
     const upsellModals = document.querySelectorAll('.upsell-modal');
     const section_url = window.location.pathname;

     //Move modals
     const mainSite = document.querySelector('main') || 0;
     const upsellModalWrapper = document.querySelector('.upsell-modals');
     mainSite && document.body.appendChild(upsellModalWrapper);

     let formData = {
          'form_type': 'product',
          'items': [],
          'section-id': '',
          'sections': "cart-drawer,cart-icon-bubble",
          'sections_url': section_url
     }

     // reset data
     function resetFormData() {
          formData = {
               'form_type': 'product',
               'items': [],
               'section-id': '',
               'sections': "cart-drawer,cart-icon-bubble",
               'sections_url': section_url
          };
     }

     let countdownInterval;

     function upSellCountDown(time) {

          let countdownTime = time;

          const countdownElements = document.querySelectorAll('.upsell-countdown');

          function formatTime(seconds) {
               const minutes = Math.floor(seconds / 60);
               const remainingSeconds = seconds % 60;
               return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
          }

          if (countdownInterval) {
               clearInterval(countdownInterval);
          }

          function startCountdown() {

               let timeLeft = countdownTime;

               countdownInterval = setInterval(() => {
                    timeLeft--;

                    countdownElements.forEach(el => {
                         el.innerText = formatTime(timeLeft);
                    });

                    if (timeLeft <= 0) {
                         clearInterval(countdownInterval);
                    }
               }, 1000);
          }

          countdownElements.forEach(el => {
               el.innerText = formatTime(countdownTime);
          });
          startCountdown();
     }


     //Fetch upsells
     const upsellGet = `https://app.thebalmydrum.com/api/upsell`;
     fetch(upsellGet, {
          method: 'GET',
          headers: {
               'Content-Type': 'application/json'
          }
     }).then(function(response) { return response.json(); }).then( json => {
          //if its set active, fire the app
          json.active == true && upsellApp(json);
     });


     //Start app
     function upsellApp(app){

          //details about offer
          var elAvailable, elMain, elSize, elColor, elOffer, elSelectedProduct, elColor, elActive = false;
          function findElems(item){
               const target = app.upsells.find(el => el.variants.includes(item.toString()));
               if (target){
                    elAvailable = true;
                    elMain = target.category;
                    elSize = target.size;
                    elOffer = target.offers;
                    elColor = target.color;
                    elActive = target.active;
                    elSelectedProduct = target.addSelectedProduct;
               } else{
                    elAvailable = false;
               }
          }

          //Hide on top buttons
          if (app.hiddenButtonsOnTop.enabled){
               const buttons = upsellModalWrapper.querySelectorAll('.upsell-modal__buttons');
               buttons.forEach(el => el.classList.add('hot-mode'));
          }

          pageForms.forEach(function(form){
     
               const btn = form.querySelectorAll('button[type="submit"]');
               
               Array.from(btn).forEach(function(b){
     
                    el => el.classList.add('submit-with-upsell');

                    b.addEventListener('click', function(ev){

                         const cartDrawer = document.querySelector('cart-drawer') ? document.querySelector('cart-drawer') : document.querySelector('.cart-drawer') ;
                         const cartBubble = document.querySelector('#cart-icon-bubble');


                         //Get correct quantity item
                         const quantityItem = form.querySelector('input#product__quantity') || form.querySelector('input[name="quantity"]') || form.querySelector('.quantity__input') || 0;

                         //Get quantity and variation
                         const variant = form.querySelector('input[name="id"]').value;
                         const quant = quantityItem ? quantityItem.value : 1;
                         //const size = form.querySelector('input[name="size"]:checked').value;

                         //Get results from variant
                         findElems(variant);

                         if(elAvailable){

                              //Get prices of offers
                              var totalOffer = 0;
                              var compareOffer = 0
                              elOffer.forEach(el => {
                                   const off = findVariantPrice(el, 'price');
                                   totalOffer = off;
                              });

                              elOffer.forEach(el => {
                                   const off = findVariantPrice(el, 'compare');
                                   compareOffer = off;
                              });

                              document.querySelectorAll('.current-offer').forEach(el => el.innerHTML = totalOffer);

                              if(elActive){

                                   //Stop form submit
                                   ev.preventDefault();

                                   //If there is delay for firing app
                                   if (app.delay.enabled){
                                        upsellModalWrapper.classList.add('loading');
                                        setTimeout(function(){
                                             upsellModalWrapper.classList.remove('loading');
                                             fireUpsell()
                                        }, app.delay.time);
                                   } else{
                                        fireUpsell()
                                   }

                                   function upSellModalHandler(element, elSize) {
                                        let modal;
                                        const cookieName = 'zf__upsell_ab_selection';
                                        const cookieNameClassic = 'zf__upsell_view';
                                        const modalSelectorBase = `.upsell-modal[data-modal-for="${elSize}"]`;
                                        const savedSelection = getCookie(cookieName);
                                        const savedView = getCookie(cookieNameClassic);

                                        function getCookie(name) {
                                             const value = `; ${document.cookie}`;
                                             const parts = value.split(`; ${name}=`);
                                             if (parts.length === 2) return parts.pop().split(';').shift();
                                        }

                                        function setCookie(name, value, days) {
                                             const d = new Date();
                                             d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
                                             const expires = `expires=${d.toUTCString()}`;
                                             document.cookie = `${name}=${value}; ${expires}; path=/`;
                                        }

                                        if (element.ab.active) {
                                             if (savedSelection) {
                                                  modal = document.querySelector(`${modalSelectorBase}[data-ab="${savedSelection}"]`);
                                             } else {
                                                  // Rastgele seçim yap ve çerez olarak sakla
                                                  const abVariants = ['a', 'b'];
                                                  let randomSelection;
                                                  if(element.ab.a.viewAll > element.ab.b.viewAll){
                                                       randomSelection = 'b'
                                                  } else if (element.ab.a.viewAll < element.ab.b.viewAll){
                                                       randomSelection = 'a'
                                                  } else{
                                                       randomSelection = abVariants[Math.floor(Math.random() * abVariants.length)];
                                                  }
                                                  modal = document.querySelector(`${modalSelectorBase}[data-ab="${randomSelection}"]`);
                                                  setCookie(cookieName, randomSelection, 7); 
                                                  incrementView(variant, randomSelection);
                                             }
                                        } else {
                                             // A/B test is inactive, just choose correct modal
                                             if(savedView){
                                                  modal = document.querySelector(modalSelectorBase);
                                             } else{
                                                  setCookie(cookieNameClassic, 'has_view', 7); 
                                                  incrementView(variant, 'false');
                                                  modal = document.querySelector(modalSelectorBase);
                                             }
                                        }

                                        return modal;
                                   }

                                   function fireUpsell(){

                                        const element = app.upsells.find(el => el.variants.includes(variant));
                                        const modal = upSellModalHandler(element, elSize);

                                        //Fire modal if there is
                                        if (modal){

                                             //Hide body
                                             document.body.classList.add('upsell-modal-active', 'upsell-modal-main-hide');

                                             //Activate modal
                                             modal.classList.add('active', elColor);

                                             //start upsell counter
                                             upSellCountDown(180);

                                             let abResult;
                                             element.ab.active ? abResult = modal.getAttribute('data-ab') : abResult = false;

                                             if (app.hiddenButtonsOnTop.enabled){
                                                  const buttons = modal.querySelector('.upsell-modal__buttons');
                                                  const wrapper = modal.querySelector('.upsell-modal__wrapper');
                                                  modal.addEventListener('scroll', function(){
                                                       if (wrapper.offsetHeight + Number(app.hiddenButtonsOnTop.pos) + 100 > window.innerHeight){
                                                            modal.scrollTop > app.hiddenButtonsOnTop.pos ? 
                                                                 buttons.classList.add('showing')
                                                                 :
                                                                 !app.hiddenButtonsOnTop.oneTime && buttons.classList.remove('showing');
                                                            ;
                                                       } else{
                                                            buttons.classList.add('showing')
                                                       }
                                                  })
                                             }

                                        
                                             //if accept
                                             modal.querySelector('button.upsell-modal__accept').addEventListener('click', function(){

                                                  //Add selected product to cart if active
                                                  elSelectedProduct && formData.items.push(
                                                       {
                                                            'id': variant.toString(), 
                                                            'quantity': quant,
                                                       }
                                                  )

                                                  //add offers to formData
                                                  elOffer.forEach(function(el){
                                                       formData.items.push(
                                                            {
                                                                 'id': el.toString(), 
                                                                 'quantity': quant,
                                                            }
                                                       )
                                                  })
                    
                                                  fetch(window.Shopify.routes.root + 'cart/add.js', {
                                                       method: 'POST',
                                                       headers: {
                                                       'Content-Type': 'application/json'
                                                       },
                                                       body: JSON.stringify(formData)
                                                  })
                                                  .then(response => {
                                                       return response.json();
                                                  }).then(res => {

                                                       app.discount.enabled && 
                                                       fetch(window.Shopify.routes.root + `discount/${app.discount.discountCode}`).then(data => console.log(data))

                                                       // Add attribute to cart
                                                       updateCartWithNote(true, abResult);

                                                       //Cart drawer mode or move to cart
                                                       app.cartDrawer ? (
                                                            updateCartDrawerSections(cartDrawer, res.sections['cart-drawer'], cartBubble, res.sections['cart-icon-bubble']),
                                                            //Show back main
                                                            document.body.classList.remove('upsell-modal-active', 'upsell-modal-main-hide'),
                                                            //Close active modal
                                                            modal.classList.remove('active'),
                                                            modal.classList.remove(elColor)

                                                       )
                                                       :
                                                       (
                                                            window.location.href = '/cart'
                                                       )


                                                       resetFormData();
                    
                                                  })
                                                  .catch((error) => {
                                                       //console.error('Error:', error);
                                                  });
                                                  
                                             })

                                             //if decline
                                             modal.querySelector('button.upsell-modal__dismiss').addEventListener('click', function(){

                                                  //Add selected product to cart if active
                                                  formData.items.push({'id': variant.toString(), "quantity": quant})
                    
                                                  fetch(window.Shopify.routes.root + 'cart/add.js', {
                                                       method: 'POST',
                                                       headers: {
                                                       'Content-Type': 'application/json'
                                                       },
                                                       body: JSON.stringify(formData)
                                                  })
                                                  .then(response => {
                                                       return response.json();
                                                  }).then(res => {
                                                       updateCartWithNote(false, abResult);

                                                       //Cart drawer mode or move to cart
                                                       app.cartDrawer ? (
                                                            updateCartDrawerSections(cartDrawer, res.sections['cart-drawer'], cartBubble, res.sections['cart-icon-bubble']),
                                                            //Show back main
                                                            document.body.classList.remove('upsell-modal-active', 'upsell-modal-main-hide'),
                                                            //Close active modal
                                                            modal.classList.remove('active'),
                                                            modal.classList.remove(elColor)
                                                       )
                                                       :
                                                       (
                                                            window.location.href = '/cart'
                                                       )

                                                       resetFormData();

                    
                                                  })
                                                  .catch((error) => {
                                                       console.error('Error:', error);
                                                  });
                                                  
                                             })

                                        }
                                   }


                              }


                         }
                         
                         
                    })
     
               });
               
          
          
          
          })


     }



})
